"use strict";

// import Chart from "../Custom/Chart/Chart";
import _styled from "styled-components";
var _class, _DataPreview;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import CatalogFunctionMixin from "../../ModelMixins/CatalogFunctionMixin";
import ReferenceMixin from "../../ModelMixins/ReferenceMixin";
import InvokeFunction from "../Analytics/InvokeFunction";
import Loader from "../Loader";
import Description from "./Description";
import GroupPreview from "./GroupPreview";
import MappablePreview from "./MappablePreview";
import WarningBox from "./WarningBox";
import Styles from "./data-preview.scss";
import Icon from "../../Styled/Icon";

/**
 * Data preview section, for the preview map see DataPreviewMap
 */
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
let DataPreview = observer(_class = (_DataPreview = class DataPreview extends Component {
  backToMap() {
    runInAction(() => {
      this.props.viewState.explorerPanelIsVisible = false;
    });
  }
  renderInner() {
    const {
      t
    } = this.props;
    let previewed = this.props.previewed;
    if (previewed !== undefined && ReferenceMixin.isMixedInto(previewed)) {
      // We are loading the nested target because we could be dealing with a nested reference here
      if (previewed.nestedTarget === undefined) {
        // Reference is not available yet.
        return this.renderUnloadedReference();
      }
      previewed = previewed.nestedTarget;
    }
    let chartData;
    if (previewed && !previewed.isMappable && previewed.tableStructure) {
      chartData = previewed.chartData();
    }
    if (previewed && previewed.isLoadingMetadata) {
      return /*#__PURE__*/_jsxs("div", {
        className: Styles.previewInner,
        children: [/*#__PURE__*/_jsx("h3", {
          className: Styles.h3,
          children: previewed.name
        }), /*#__PURE__*/_jsx(Loader, {})]
      });
    } else if (previewed && previewed.isMappable) {
      return /*#__PURE__*/_jsx("div", {
        className: Styles.previewInner,
        children: /*#__PURE__*/_jsx(MappablePreview, {
          previewed: previewed,
          terria: this.props.terria,
          viewState: this.props.viewState
        })
      });
    } else if (chartData) {
      return /*#__PURE__*/_jsxs("div", {
        className: Styles.previewInner,
        children: [/*#__PURE__*/_jsx("h3", {
          className: Styles.h3,
          children: previewed.name
        }), /*#__PURE__*/_jsx("p", {
          children: t("preview.doesNotContainGeospatialData")
        }), /*#__PURE__*/_jsx("div", {
          className: Styles.previewChart
        }), /*#__PURE__*/_jsx(Description, {
          item: previewed
        })]
      });
    } else if (previewed && CatalogFunctionMixin.isMixedInto(previewed)) {
      return /*#__PURE__*/_jsx(InvokeFunction, {
        previewed: previewed,
        terria: this.props.terria,
        viewState: this.props.viewState
      });
    } else if (previewed && previewed.isGroup) {
      return /*#__PURE__*/_jsx("div", {
        className: Styles.previewInner,
        children: /*#__PURE__*/_jsx(GroupPreview, {
          previewed: previewed,
          terria: this.props.terria,
          viewState: this.props.viewState
        })
      });
    } else if (this.props.terria.configParameters.keepCatalogOpen) {
      return null;
    } else {
      return /*#__PURE__*/_jsxs("div", {
        className: Styles.placeholder,
        children: [/*#__PURE__*/_jsx("p", {
          children: t("preview.selectToPreviewDataset")
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsxs(Trans, {
            i18nKey: "preview.selectMultipleDatasets",
            children: [/*#__PURE__*/_jsxs("span", {
              children: ["Press ", /*#__PURE__*/_jsx("strong", {
                children: "Shift"
              }), " and click"]
            }), /*#__PURE__*/_jsx(_StyledIcon, {
              glyph: Icon.GLYPHS.add,
              $_css: "".concat(p => p.theme.charcoalGrey)
            }), /*#__PURE__*/_jsx("span", {
              children: "to add multiple datasets"
            })]
          })
        }), /*#__PURE__*/_jsxs("p", {
          children: ["- ", t("preview.selectToPreviewSeparator"), " -"]
        }), /*#__PURE__*/_jsx("button", {
          className: Styles.btnBackToMap,
          onClick: () => this.backToMap(),
          children: t("preview.goToTheMap")
        })]
      });
    }
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      className: Styles.preview,
      children: this.renderInner()
    });
  }
  renderUnloadedReference() {
    var _this$props$previewed, _this$props$previewed2, _this$props$previewed3;
    const isLoading = this.props.previewed.isLoadingReference;
    const hasTarget = this.props.previewed.target !== undefined;
    return /*#__PURE__*/_jsx("div", {
      className: Styles.preview,
      children: /*#__PURE__*/_jsxs("div", {
        className: Styles.previewInner,
        children: [isLoading && /*#__PURE__*/_jsx(Loader, {}), !isLoading && !hasTarget && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: Styles.placeholder,
            children: [/*#__PURE__*/_jsx("h2", {
              children: "Unable to resolve reference"
            }), !((_this$props$previewed = this.props.previewed.loadReferenceResult) !== null && _this$props$previewed !== void 0 && _this$props$previewed.error) ? /*#__PURE__*/_jsx("p", {
              children: "This reference could not be resolved because it is invalid or because it points to something that cannot be visualised."
            }) : null]
          }), (_this$props$previewed2 = this.props.previewed.loadReferenceResult) !== null && _this$props$previewed2 !== void 0 && _this$props$previewed2.error ? /*#__PURE__*/_jsx(WarningBox, {
            error: (_this$props$previewed3 = this.props.previewed.loadReferenceResult) === null || _this$props$previewed3 === void 0 ? void 0 : _this$props$previewed3.error,
            viewState: this.props.viewState
          }) : null]
        })]
      })
    });
  }
}, _defineProperty(_DataPreview, "propTypes", {
  terria: PropTypes.object.isRequired,
  viewState: PropTypes.object,
  previewed: PropTypes.object,
  t: PropTypes.func.isRequired
}), _DataPreview)) || _class;
export default withTranslation()(DataPreview);
var _StyledIcon = _styled(Icon).withConfig({
  displayName: "DataPreview___StyledIcon",
  componentId: "sc-isizez-0"
})(p => ({
  height: "20px",
  width: "20px",
  margin: "0px 5px",
  verticalAlign: "middle",
  fill: p.$_css
}));